document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".faq__question");

  faqQuestions.forEach((question) => {
    question.addEventListener("click", function () {
      const parentItem = this.parentElement;
      parentItem.classList.toggle("is-open");
    });
  });
});
